import { createSlice } from "@reduxjs/toolkit";
import {} from "../action/authAction";
import {
  contactUs,
  fetchDashboard,
  fetchServiceDetailById,
  fetchServices,
  fetchWeightRestriction,
} from "../action/homeAction";

const initialState = {
  isLoading: false,
  homeData: {},
  serviceList: [],
  serviceDetail: {},
  weightClassRestrictions: [],
  selectedClassRestriction: "",
};

export const homeSlice = createSlice({
  name: "home",
  initialState: initialState,
  reducers: {
    selectClassRestriction: (state, action) => {
      state.selectedClassRestriction = action?.payload;
    },
  },
  extraReducers: (builder) => {
    // fetch-dashboard-details
    builder.addCase(fetchDashboard.fulfilled, (state, action) => {
      const { data } = action?.payload || {};
      state.homeData = data ?? {};
      state.isLoading = false;
    });
    builder.addCase(fetchDashboard.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchDashboard.rejected, (state, action) => {
      state.isLoading = false;
    });

    // fetch-services
    builder.addCase(fetchServices.fulfilled, (state, action) => {
      const { data } = action?.payload || {};
      state.serviceList = data ?? [];
      state.isLoading = false;
    });
    builder.addCase(fetchServices.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchServices.rejected, (state, action) => {
      state.isLoading = false;
    });
    // fetch-services-detaili-by-id
    builder.addCase(fetchServiceDetailById.fulfilled, (state, action) => {
      const { data } = action?.payload || {};
      state.serviceDetail = data ?? [];
      state.isLoading = false;
    });
    builder.addCase(fetchServiceDetailById.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchServiceDetailById.rejected, (state, action) => {
      state.isLoading = false;
    });
    // fetch-services-detaili-by-id
    builder.addCase(contactUs.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(contactUs.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(contactUs.rejected, (state, action) => {
      state.isLoading = false;
    });
    // fetch-wieght-restrictions
    builder.addCase(fetchWeightRestriction.fulfilled, (state, action) => {
      const { data } = action?.payload || {};
      state.weightClassRestrictions = data ?? [];
      state.selectedClassRestriction = data
        ? data[0]
        : "";
      state.isLoading = false;
    });
    builder.addCase(fetchWeightRestriction.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchWeightRestriction.rejected, (state, action) => {
      state.isLoading = false;
    });
  },
});

export const { toggleChange ,selectClassRestriction} = homeSlice.actions;
export default homeSlice.reducer;
